import { formatDate } from "../utils/datetime.js"
/**
 * 自动生成20位ID
 */
export function build20Id () {
  var code = formatDate(new Date(), 'yyMMddhhmmssS');
  return code + createCode(5);
}

/**
 * 获取指定位数的随机数
 * 
 * @param codeLength:设置长度
 */
export function createCode (codeLength) {
  var code = '';

  //设置随机字符
  var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);

  //循环codeLength 我设置的4就是循环4次
  for (var i = 0; i < codeLength; i++) {
    //设置随机数范围,这设置为0 ~ 36
    var index = Math.floor(Math.random() * 9);

    //字符串拼接 将每次随机的字符 进行拼接
    code += random[index];
  }

  //将拼接好的字符串赋值给展示的code
  return code;
}




// WEBPACK FOOTER //
// ./src/utils/buildId.js